/** Sort by lowercase `title` field. */
export function sortByTitle<T extends { title?: string }>(a: T, b: T): number {
	return (a.title ?? "").localeCompare(b.title ?? "");
}

/** Sort by capital `Title` field. */
export function sortByTitleCapital<T extends { Title?: string }>(a: T, b: T): number {
	return (a.Title ?? "").localeCompare(b.Title ?? "");
}
